import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppShell as MantineAppShell, Text } from '@mantine/core';
import { Box } from '@xhr-labs/core-ui';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

const HEADER_HEIGHT = 60;
const SIDEBAR_WIDTH_COLLAPSED = 60;
const SIDEBAR_WIDTH_EXPANDED = 272;

export function AppShell() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <MantineAppShell
      header={{ height: HEADER_HEIGHT }}
      navbar={{
        width: sidebarCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED,
        breakpoint: 'sm',
        collapsed: { mobile: sidebarCollapsed },
      }}
      padding="lg"
      styles={{
        main: {
          backgroundColor: 'var(--xhr-color-bg-surface)',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        },
        header: {
          backgroundColor: 'color-mix(in srgb, var(--v2-color-neutral-1) 92%, transparent)',
          backdropFilter: 'blur(8px)',
        },
        navbar: {
          backgroundColor: 'transparent',
        },
      }}
    >
      <MantineAppShell.Header>
        <Header onMenuClick={toggleSidebar} />
      </MantineAppShell.Header>

      <MantineAppShell.Navbar>
        <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} />
      </MantineAppShell.Navbar>

      <MantineAppShell.Main>
        <Box
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--xhr-pad-md)',
            width: '100%',
            maxWidth: 1680,
            marginInline: 'auto',
          }}
        >
          <Box
            style={{
              flex: 1,
              minHeight: 0,
              paddingBottom: 'var(--xhr-pad-md)',
            }}
          >
            <Outlet />
          </Box>
          <Text size="xs" c="dimmed" ta="center" py="sm">
            © 2026 Admin Portal v0.1.0
          </Text>
        </Box>
      </MantineAppShell.Main>
    </MantineAppShell>
  );
}
